import styled from "styled-components";
import colors from "../../constants/colors";

export const Button = styled("button")<{
  $secondary?: boolean;
  $warning?: boolean;
  $noWidth?: boolean;
  $noMarginTop?: boolean;
  disabled: boolean;
}>(({ $secondary, $warning, $noWidth, $noMarginTop, disabled }) => ({
  padding: $noWidth ? "0.5rem 0.875rem" : "1rem 1.5rem",
  fontSize: $noWidth ? "0.8125rem" : $secondary || $warning ? "16px" : "18px",
  fontWeight: 600,
  background: disabled
    ? colors.GREY_3
    : $secondary
      ? colors.WHITE
      : $warning
        ? colors.GRADIENT_RED
        : colors.GRADIENT_PURPLE,
  color: disabled ? colors.GREY_6 : $secondary ? colors.PURPLE : colors.WHITE,
  border: $secondary ? `2px solid ${colors.PURPLE}` : "none",
  borderRadius: $noWidth ? "8px" : "12px",
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: 1,
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  width: $noWidth ? "auto" : "100%",
  minHeight: $noWidth ? "44px" : "auto", // WCAG 2.1 AA minimum touch target size
  marginTop: $noMarginTop ? 0 : "2rem",
  boxShadow: disabled
    ? "none"
    : $secondary
      ? `0px 2px 8px ${colors.SHADOW_PURPLE_LIGHT}`
      : `0px 4px 12px ${colors.SHADOW_PURPLE_MEDIUM}`,
  position: "relative" as const,
  overflow: "hidden" as const,
  whiteSpace: "nowrap" as const,

  "&:active:not(:disabled)": {
    boxShadow: disabled
      ? "none"
      : $secondary
        ? `0px 1px 4px ${colors.SHADOW_PURPLE_LIGHT}`
        : `0px 2px 6px ${colors.SHADOW_PURPLE_MEDIUM}`,
  },

  "&:focus-visible": {
    outline: "none",
    boxShadow: `0px 0px 0px 4px ${colors.FOCUS_RING}`,
  },
}));
